import type { Experience } from './experiences';

// Romania experiences. All photos are real, freely-licensed images illustrating
// each actual experience/region, sourced from Wikimedia Commons (CC BY-SA).
export const experiencesRomania: Experience[] = [
  {
    id: 1,
    title: 'Transylvania & Dracula Trail',
    subtitle: 'Castles, Citadels & Legends',
    description: 'Follow the legend through Bran Castle, the medieval citadel of Sighișoara, and the fairytale Peleș Palace. Expert guides reveal the real history behind the myth across Saxon Transylvania.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407038576_f3a526f0.jpg',
    alt: 'Bran Castle in Transylvania, Romania, the iconic Gothic fortress at the heart of the Dracula legend.',
    duration: '4-8 days',
  },
  {
    id: 2,
    title: 'Carpathian Mountain Adventure',
    subtitle: 'Peaks, Ridges & Wildlife',
    description: 'Drive the legendary Transfăgărășan road, hike the ridges of Piatra Craiului, and track brown bears in one of Europe\'s last great wildernesses, staying in mountain chalets along the way.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407057205_9a1931d0.png',
    alt: 'The winding Transfăgărășan road through the Făgăraș Mountains of the Romanian Carpathians.',
    duration: '5-9 days',
  },
  {
    id: 3,
    title: 'Painted Monasteries of Bucovina',
    subtitle: 'Byzantine Masterpieces',
    description: 'Journey through rolling northern hills to the UNESCO-listed painted monasteries, where vivid 15th-century frescoes glow in the famous Voroneț blue. A pilgrimage through living Byzantine art.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407144146_47a87a8c.png',
    alt: 'Voroneț Monastery in Bucovina, Romania, covered in vivid blue exterior frescoes.',
    duration: '3-6 days',
  },
  {
    id: 4,
    title: 'Danube Delta Safari',
    subtitle: 'Europe\'s Wild Wetland',
    description: 'Glide through the channels of the Danube Delta Biosphere Reserve aboard traditional boats, spotting pelicans, herons, and over 300 bird species in Europe\'s largest and wildest wetland.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69c20284ac08f4efe2afa592_1782757845667_d29e972a.jpeg',
    alt: 'Great white pelicans on the channels of the Danube Delta at sunset, a UNESCO Biosphere Reserve in Romania.',
    duration: '3-5 days',
  },
  {
    id: 5,
    title: 'Culinary Romania',
    subtitle: 'Taste the Tradition',
    description: 'From hearty sarmale and mămăligă in Maramureș farmhouses to celebrated Cotnari and Murfatlar wines, savour Romania\'s rich rural cuisine through farm-to-table feasts and vineyard tastings.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782406991780_948d51c0.jpg',
    alt: 'Traditional Romanian sarmale (cabbage rolls) served with mămăligă polenta, a classic farm-to-table dish.',
    duration: '4-7 days',
  },
  {
    id: 6,
    title: 'Saxon Villages & Boutique Stays',
    subtitle: 'Heritage Reimagined',
    description: 'Stay in lovingly restored Saxon manor houses and fortified-church villages across Transylvania, blending centuries of heritage with quiet contemporary luxury and authentic countryside life.',
    image: 'https://d64gsuwffb70l.cloudfront.net/69cbf6b38dc4f4af5d55476d_1782407013829_a9ba8309.png',
    alt: 'The fortified Saxon church of Viscri, a UNESCO-listed village in Transylvania, Romania.',
    duration: '3-10 nights',
  },
];
